<template>
  <div class="content">
        <div class="shell">
            <div class="articles-excerpt" v-if="this.$store.getters.bookmarks">
                <article-excerpt
                    v-for="article in this.$store.getters.bookmarks"
                    :key="article.id"
                    :title="article.title"
                    :author="authors(article)"
                    :readingsCount="article.readings"
                    :rating="article.rating"
                    :coverSrc="cover(article)"
                    :url="url(article.id)"
                    :showDropdown="false"
                />

                <div class="articles-excerpt__actions">
                    <base-button @click="toggleModal" variant="fab">
                        Consiglia un libro

                        <span>
                            <icon-plus />
                        </span>
                    </base-button>
                </div>
            </div>

            <div v-else class="bookmarks-message">
                <div class="bookmarks-message__inner">
                    <div class="bookmarks-message__image">
                        <img :src="require(`@/assets/images/no-bookmarks.svg`)" alt="">
                    </div>

                    <h2 class="h1"><strong>Comincia la lettura di un libro</strong></h2>

                    <div class="bookmarks-message__actions">
                        <base-button to="/home" variant="outlined-primary">Vai alla biblioteca</base-button>
                    </div>
                </div>
            </div>

            <teleport to="#modal-target">
                <modal
                    v-if="showModal"
                    @on-modal-close="toggleModal"
                    defaultActive
                >
                    <template #default="{closeModal}">
                        <form-recommend @on-submit="data => handleFormSubmit(data)">
                            <template #cancelBtn>
                                <base-button
                                    type="button"
                                    @click="closeModal"
                                    variant="outlined-primary"
                                >Annulla</base-button>
                            </template>
                        </form-recommend>
                    </template>
                </modal>
            </teleport>
        </div>
    </div>
</template>

<script>
import { ref, inject, onMounted } from 'vue';
import ArticleExcerpt from '@/components/article-excerpt/article-excerpt'
import BaseButton from '@/components/base-button/base-button'
import IconPlus from '@/components/icons/icon-plus/icon-plus'
import Modal from '@/components/modal/modal'
import FormRecommend from '@/blocks/form-recommend/form-recommend'
import {useStore} from "vuex";

export default {
    name: 'BookmarksPage',

    components: {
        ArticleExcerpt,
        BaseButton,
        IconPlus,
        Modal,
        FormRecommend
    },

    setup() {
        const showModal = ref(false);
        const articles = ref([]);

        const store = useStore();        
        const toast = inject("toast");        

        /**
        const articles = ref([
            {
                id: '1',
                title: 'Do you have the experience',
                author: 'Frank Lee',
                readings: 41,
                rating: '5',
                url: '/book/1',
                image: require('@/assets/images/temp/article-6.png')
            },
            {
                id: '2',
                title: 'The expectations',
                author: 'Sarah Perez',
                readings: 7,
                rating: '4.0',
                url: '/book/1',
                image: require('@/assets/images/temp/article-9.png')
            },
            {
                id: '3',
                title: 'The Vocabulary of Style',
                author: 'John Woo',
                readings: 10,
                rating: '4.5',
                url: '/book/1',
                image: require('@/assets/images/temp/article-5.png')
            },
        ]);
        */

        const toggleModal = () => {
            showModal.value = !showModal.value
        }

        const handleFormSubmit = (data) => {
            store.dispatch('bookSuggestion', data)
            .then(function(result) {
                toast.success('Suggerimento inviato!', {
                    position: 'bottom'
                })
                toggleModal();
            })
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        }

        onMounted(() => {
            store.dispatch('loadBookmarks')
            .then(function(data) {
                articles.value = data;
            })
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        })    
        
        function cover(book) {
            return book.cdn ? 
                book.cdn : 
                apipath + '/cache/images/book-cover/' + book.id;
        }

        function url(id) {
            return '/book/' + id;
        }

        function authors(book) {
            return book.authors.map(function(e) {
                return e.description;
            }).join(',') 
        }

        return {
            articles,
            showModal,
            toggleModal,
            handleFormSubmit,
            authors,
            cover,
            url
        }
    }
}
</script>
